<template>
  <section class="container">
    <section>
      <el-button
        type="primary"
        plain
        @click="toEdit">编辑</el-button>
    </section>
    <el-form
      class="form-class"
      label-width="150px"
      label-position="left">
      <el-form-item label="标题">
        <!-- <el-input v-model="editObject.carousel_title"/> -->
        <span v-text="slideshowData.carousel_title"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <!-- <el-input v-model="editObject.carousel_title"/> -->
        <span v-text="slideshowData.carousel_english_title"/>
      </el-form-item>
      <el-form-item label="跳转链接">
        <!-- <el-input v-model="editObject.carousel_url"/> -->
        <span v-text="slideshowData.carousel_url"/>
      </el-form-item>
      <el-form-item label="权重">
        <!-- <el-input v-model="editObject.carousel_sort"/> -->
        <span v-text="slideshowData.carousel_sort"/>
      </el-form-item>
      <el-form-item label="图片">
        <img
          v-if="slideshowData.carousel_img"
          :src="qiniuDomain + slideshowData.carousel_img"
          class="avatar">
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  slideshowDetail,
} from '@/api/slideshow'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      slideshowData: {},
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().slideshowDetail()
  },
  methods: {
    toEdit() {
      this.$router.push({
        path: `/slideshow-edit/${this.$route.params.uuid}`,
      })
    },
    event() {
      return {
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        slideshowDetail: async () => {
          const { status, data } = await slideshowDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.slideshowData = data
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.form-class {
  padding: 50px;
}
.avatar {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/slideshow/detail.vue